import { CourseOption } from "../../types/course.response";
import { MutationResult } from "../../types/mutation.response";
import { putUserItem, removeUserItemById } from "../userCourseCache";
import { apiClient } from "./client.api";
import { fulfillmentParams } from "./user-courses.api";

interface ExamRequirementOverride {
    requirementId: string;
    nodeId: string;
    overrideType: 'FORCE_APPLY' | 'FORCE_UNAPPLY';
}

export const userExamsApi = {
    getExams: async (): Promise<CourseOption[]> => {
        const response = await apiClient.get('/user-exams');
        return response.data.data;
    },
    addExam: async (
        examId: string,
        score: number | null | undefined,
        scoreAlpha: string | null | undefined,
        creditsReceived: number | null | undefined,
        overrides: ExamRequirementOverride[],
        fulfillmentProgramIds?: string[],
    ): Promise<MutationResult<CourseOption>> => {
        const response = await apiClient.post('/user-exams', {
            examId,
            score,
            scoreAlpha,
            creditsReceived,
            overrides,
        }, { params: fulfillmentParams(fulfillmentProgramIds) });
        putUserItem(response.data.data); // §3.4-b 双写
        return response.data;
    },
    updateExam: async (
        userExamId: number,
        updates: {
            score?: number | null;
            scoreAlpha?: string | null;
            creditsReceived?: number | null;
        },
        fulfillmentProgramIds?: string[],
    ): Promise<MutationResult<CourseOption>> => {
        const response = await apiClient.patch(`/user-exams/${userExamId}`, updates, {
            params: fulfillmentParams(fulfillmentProgramIds),
        });
        putUserItem(response.data.data); // §3.4-b 双写
        return response.data;
    },
    deleteExam: async (
        userExamId: number,
        fulfillmentProgramIds?: string[],
    ): Promise<MutationResult<void>> => {
        const response = await apiClient.delete(`/user-exams/${userExamId}`, {
            params: fulfillmentParams(fulfillmentProgramIds),
        });
        removeUserItemById(userExamId); // §3.4-b 双写(删)
        return response.data;
    },
    addOverride: async (
        userExamId: number,
        override: ExamRequirementOverride,
        fulfillmentProgramIds?: string[],
    ): Promise<MutationResult<void>> => {
        const response = await apiClient.put(`/user-exams/${userExamId}/requirement-overrides`, override, {
            params: fulfillmentParams(fulfillmentProgramIds),
        });
        return response.data;
    },
    deleteOverride: async (
        userExamId: number,
        requirementId: string,
        fulfillmentProgramIds?: string[],
    ): Promise<MutationResult<void>> => {
        const response = await apiClient.delete(`/user-exams/${userExamId}/requirement-overrides/${requirementId}`, {
            params: fulfillmentParams(fulfillmentProgramIds),
        });
        return response.data;
    },
}
